export const MeetingState_Both_SelfCancelled = [
    '$scope', function($scope) {
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/consultations/meetingStates/both/selfCancelled.html';
    },
];
